import { IBaseResponse, ICenterBase, IOptnSrtrValidation } from '@nkr/models/index';
import { ICenterUnosDataMonthly } from '@nkr/models/center-profile/index';
import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '../';
import { IPost } from '../authorization';
import { IDelete, IGet, IPut } from '../authorization/actions';

export interface IOptnSrtrDataUploadResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            fileName: string,
            columns: string[],
            sampleRow: string[]
        }
    }
}

export interface IOptnSrtrDataValidateResponse {
    data: {
        success: boolean,
        message: string,
        results: IOptnSrtrValidation[]
    }
}

export interface IOptnSrtrDataProcessResponse {
    data: {
        success: boolean,
        message: string,
        results: number
    }
}

export interface IOptnSrtrDataProgressResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            progressModel: {
                rowsProcessed: number,
                rowsAdded: number,
                rowsUpdated: number,
                rowsSkipped: number
            },
            isComplete: boolean
        }
    }
}

export interface IOptnSrtrMonthlyDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            data: ICenterUnosDataMonthly[],
            centers: ICenterBase[]
        }
    }
}

export interface IOptnSrtrMonthlyDataAddResponse {
    data: {
        success: boolean,
        message: string,
        results: ICenterUnosDataMonthly
    }
}

export interface IUpdateOptnSrtrData {
    id: number,
    centerId: number,
    dataDate: string,

    ddTxps: string,
    ldTxps: string,
    wlTotal: string,
    wlActive: string,

    lda: string,
    ldb: string,
    ldab: string,
    ldo: string,

    ldra: string,
    ldrb: string,
    ldrab: string,
    ldro: string,
}

export const ActionCreators = {
    uploadOptnSrtrData: (hasColumnHeaders: boolean, file: File) => async (dispatch: Dispatch<IApplicationState>): Promise<IOptnSrtrDataUploadResponse> => {
        let formData = new FormData();

        formData.append('hasColumnHeaders', hasColumnHeaders.toString());
        formData.append('file', file);

        let config = {
            url: `${__API__}/public/optn-srtr-data/upload`,
            data: formData
        };

        return await dispatch(AuthActionCreators.apiPostPublic(config));
    },
    validateOptnSrtrData: (fileName: string, hasColumnHeaders: boolean, columnMappings: string[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IOptnSrtrDataValidateResponse> => {
        let options = {
            url: `${__API__}/public/optn-srtr-data/validate`,
            data: {
                fileName,
                hasColumnHeaders,
                columnMappings
            }
        };

        return await dispatch(AuthActionCreators.apiPostPublic(options));
    },
    processOptnSrtrData: (fileName: string, hasColumnHeaders: boolean, columnMappings: string[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IOptnSrtrDataProcessResponse> => {
        let options: IPost = {
            url: `${__API__}/public/optn-srtr-data/process`,
            data: {
                fileName,
                hasColumnHeaders,
                columnMappings
            },
        };

        return await dispatch(AuthActionCreators.apiPostPublic(options));
    },
    getOptnSrtrProgress: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IOptnSrtrDataProgressResponse> => {
        let options: IPost = {
            url: `${__API__}/public/optn-srtr-data/${id}/progress`,
        };

        return await dispatch(AuthActionCreators.apiGetPublic(options));
    },
    getOptnSrtrMonthlyData: () => async (dispatch: Dispatch<IApplicationState>): Promise<IOptnSrtrMonthlyDataResponse> => {
        let options: IGet = {
            url: `${__API__}/public/optn-srtr-data`,
        };

        return await dispatch(AuthActionCreators.apiGetPublic(options));
    },
    updateOptnSrtrData: (list: IUpdateOptnSrtrData[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPut = {
            url: `${__API__}/public/optn-srtr-data`,
            data: list
        };

        return await dispatch(AuthActionCreators.apiPutPublic(options));
    },
    addOptnSrtrData: (data: IUpdateOptnSrtrData) => async (dispatch: Dispatch<IApplicationState>): Promise<IOptnSrtrMonthlyDataAddResponse> => {
        let options: IPost = {
            url: `${__API__}/public/optn-srtr-data`,
            data
        };

        return await dispatch(AuthActionCreators.apiPostPublic(options));
    },
    deleteOptnSrtrData: (list: number[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IDelete = {
            url: `${__API__}/public/optn-srtr-data?requestList=${list.join(',')}`,
        };

        return await dispatch(AuthActionCreators.apiDeletePublic(options));
    },
}